import { render, staticRenderFns } from "./listOfPrograms.vue?vue&type=template&id=532761d3&scoped=true&"
import script from "./listOfPrograms.vue?vue&type=script&lang=ts&"
export * from "./listOfPrograms.vue?vue&type=script&lang=ts&"
import style0 from "./listOfPrograms.vue?vue&type=style&index=0&id=532761d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532761d3",
  null
  
)

export default component.exports